jQuery(document).ready(function($){
	$('[class*="sc-onclick--"]').on('click', function(){
		const classParts = $(this).attr('class').split(/\s+/);
		$.each(classParts, function(index, value){
			if(value.includes('sc-onclick--')) {
				let target = value.replace('sc-onclick--', '');
				target = target.replace('class--', '.');
				target = target.replace('id--', '#');
				$(target).click();
			}
		});
	});
});